/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectPlusIcon20Solid = forwardRef('CommentRectPlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-4.857l-3.53 2.745A1 1 0 0 1 5 16.955V15a3 3 0 0 1-3-3V5Zm8.875.5a.875.875 0 0 0-1.75 0v2.125H7a.875.875 0 1 0 0 1.75h2.125V11.5a.875.875 0 0 0 1.75 0V9.375H13a.875.875 0 0 0 0-1.75h-2.125V5.5Z" })));
});
